<app-header-list titulo="Lista de Monitoramentos"/>

<ion-content [fullscreen]="true">
  <p-table [lazy]="true" [totalRecords]="total" (onLazyLoad)="load($event)" #dt1 styleClass="p-datatable-striped"
           sortMode="multiple"
           [multiSortMeta]="[{field: 'inicio', order: -1}]"
           [showCurrentPageReport]="true" responsiveLayout="scroll"
           currentPageReportTemplate="{first}-{last}/{totalRecords}"
           [pageLinks]="0"
           [rows]="100" [paginator]="true"  dataKey="id" [value]="entidades">
    <ng-template pTemplate="header">
      <tr style="vertical-align: top">

        <th pSortableColumn="inicio"> Início<br/>
          <div style="white-space: nowrap;">
            <p-sortIcon field="inicio"></p-sortIcon>
            <p-columnFilter display="menu" type="text" field="inicio"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="fim"> Fim<br/>
          <div style="white-space: nowrap;">
            <p-sortIcon field="fim"></p-sortIcon>
            <p-columnFilter display="menu" type="text" field="fim"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="projeto.nome"> Projeto<br/>
          <div style="white-space: nowrap;">
            <p-sortIcon field="projeto.nome"></p-sortIcon>
            <p-columnFilter display="menu" type="text" field="projeto.nome"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="campanha.nome"> Campanha<br/>
          <div style="white-space: nowrap;">
            <p-sortIcon field="campanha.nome"></p-sortIcon>
            <p-columnFilter display="menu" type="text" field="campanha.nome"></p-columnFilter>
          </div>
        </th>

        <th pSortableColumn="local.nome"> Local<br/>
          <div style="white-space: nowrap;">
            <p-sortIcon field="local.nome"></p-sortIcon>
            <p-columnFilter display="menu" type="text" field="local.nome"></p-columnFilter>
          </div>
        </th>
        <th> Tracking
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>

        <td><a routerLink="edit/{{item.id}}"> {{item.inicio | date   : 'dd/MM/yy HH:mm'}}</a></td>
        <td><a routerLink="edit/{{item.id}}"> {{item.fim | date   : 'dd/MM/yy HH:mm'}}</a></td>
        <td><a routerLink="edit/{{item.id}}"> {{item.projeto?.nome}}</a></td>
        <td><a routerLink="edit/{{item.id}}"> {{item.campanha?.nome}}</a></td>
        <td><a routerLink="edit/{{item.id}}"> {{item.local?.nome}}</a></td>
        <td>
          <div style="display: flex" >
            <ion-button (click)="showMap(item)">
              <ion-icon name="map" />
            </ion-button>
            <ion-button (click)="exportarExcel(item)" >
              xls
              <ion-icon name="download" />
            </ion-button>
            <ion-button (click)="geojson(item)" >
              json
              <ion-icon name="download" />
            </ion-button>
            <ion-button  (click)="kml(item)">
              KML
              <ion-icon name="download" />
            </ion-button>
          </div>
        </td>
      </tr>
    </ng-template>
    </p-table>
<!--    <ion-fab slot="fixed"  vertical="bottom" horizontal="end">-->
<!--      <ion-fab-button routerLink="new" color="success">-->
<!--        <ion-icon  name="add"></ion-icon>-->
<!--      </ion-fab-button>-->
<!--    </ion-fab>-->
</ion-content>

<app-rodape [exibirBotoes]="false"/>
